require('./bootstrap')
require('alpinejs')

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import Maska from 'maska'
import axios from 'axios'
import { LicenseManager } from 'ag-grid-enterprise'
import './utils/syntax/init'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

LicenseManager.setLicenseKey(process.env.MIX_AG_GRID_LICENSE)

window.Vapor = require('laravel-vapor')

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Salve Platform'
axios.defaults.withCredentials = true

createInertiaApp({
  progress: {
    color: '#FF7700'
  },
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => require(`./Pages/${name}.vue`),
  setup({ el, App, props, plugin }) {
    let vueApp = createApp({ render: () => h(App, props) })

    vueApp
      .use(plugin)
      .use(Maska)
      .use(Toast, { hideProgressBar: true, toastClassName: 'salve-toast', timeout: 2000 })
      .mixin({
        methods: {
          route,
          asset: window.Vapor.asset
        }
      })
      .mount(el)

    return vueApp
  }
})
